import {useAuthStore} from '@/store/auth_store';
import {useNotifications} from '@/hooks/useNotifications';
import WidgetPage from '@common/widgets/WidgetPage';
import WidgetOnlyShowUnread from '@common/widgets/WidgetOnlyShowUnread';
import NotificationItem from '@/components/pages/notifications/NotificationItem';
import {useQuery} from "@tanstack/react-query";
import {useContext} from "react";
import {CarecoApiContext} from "@/app-context/careco-api-context";

export default function NotificationsPage() {
  const currentUser = useAuthStore((state) => state.currentUser);

  const {
    isLoading,
    isApiLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isRefetching,
    error,
    notifications,
    totalUnreadNotifications,
    markAllAsRead,
  } = useNotifications({
    onlyShowUnreadNotifications: currentUser?.only_show_unread_notifications ?? false,
  });
  const {carecoApi} = useContext(CarecoApiContext);

  const {data: rosters} = useQuery({
    queryKey: ['rosters'],
    queryFn: () => carecoApi?.getRosters(),
    enabled: !!carecoApi,
  });

  return (
    <WidgetPage
      elements={notifications}
      totalUnreadElements={totalUnreadNotifications}
      dateProperty="notificationDate"
      title="Notifications"
      isLoading={isLoading}
      isApiLoading={isApiLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isRefetching={isRefetching}
      error={error}
      markAllAsRead={markAllAsRead}
      render={(notification) => (
        <NotificationItem
          roster={rosters?.data.data.find(roster => roster.id === notification.group.id)}
          key={notification.id}
          notification={notification}
        />
      )}
    >
      {currentUser && (
        <WidgetOnlyShowUnread
          queryKey={(u) => ['notifications', u.only_show_unread_notifications]}
          currentFetchedUser={currentUser}
          property="only_show_unread_notifications"
          label="Notifications"
        />
      )}
    </WidgetPage>
  );
}
